<template>
  <!-- Main layout for muzik content -->
  <div class="layout">
    <Alert />
    <MuzikHeader v-show="displayHeader" />
    <RouterView />
    <MuzikFooter v-show="displayFooter" />
    <MuzikPlayer />
  </div>
</template>
<script>
import MuzikHeader from '@/components/MuzikHeader'
import MuzikFooter from '@/components/MuzikFooter'
import MuzikPlayer from '@/components/MuzikPlayer'
import Alert from '@/components/common/Alert'

export default {
  name: 'Layout',
  components: {
    MuzikHeader,
    MuzikFooter,
    MuzikPlayer,
    Alert
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // console.log('vm.$i18n.locale', vm.$i18n.locale, '$route.params.locale')
      const correctLocalePath = vm.$i18n.localePath() // include prefix '/'
      const locale = vm.$route.params.locale
      if (correctLocalePath !== `${locale}`) {
        // Replacing languageCode to countryCode force in path
        vm.$router.replace({ params: { locale: correctLocalePath } })
      }
    })
  },
  props: {},
  data() {
    return {
      unlimited: false,
      displayHeader: true,
      displayFooter: true
    }
  },
  metaInfo() {
    return {
      htmlAttrs: {
        lang: this.htmlLang
      },
      meta: [
        { vmid: 'og:site_name', name: 'og:site_name', content: this.siteName }
      ],
      link: [
        { vmid: 'hreflang', rel: 'alternate', hreflang: 'zh-tw', href: this.urlPath && this.urlPath[0] },
        { vmid: 'hreflang', rel: 'alternate', hreflang: 'zh-cn', href: this.urlPath && this.urlPath[1] },
        { vmid: 'hreflang', rel: 'alternate', hreflang: 'en-us', href: this.urlPath && this.urlPath[2] },
        { vmid: 'hreflang', rel: 'alternate', hreflang: 'ja-jp', href: this.urlPath && this.urlPath[3] }
      ]
    }
  },
  computed: {
    htmlLang() {
      if (this.$i18n.locale.toLowerCase() === 'zh-tw') {
        return 'zh-Hant'
      } else if (this.$i18n.locale.toLowerCase() === 'zh-cn') {
        return 'zh-Hans'
      } else if (this.$i18n.locale.toLowerCase() === 'en-us') {
        return 'en'
      } else if (this.$i18n.locale.toLowerCase() === 'ja-jp') {
        return 'ja'
      } else {
        return 'en'
      }
    },
    siteName() {
      return `MUZIK AIR`
    },
    urlPath() {
      // const re = /(([\w]+\/){1})([^]+)(\.+)/gm
      const orinUrl = window.location.href
      const pathname = window.location.pathname.split('/')
      let langUrl = []
      let langArr = ['tw', 'cn', 'en', 'jp']
      langArr.forEach((lang, index) => {
        langUrl[index] = orinUrl.replace(pathname[1], lang)
      })
      return langUrl
    },
    isAuthenticated() { return this.$store.getters.isAuthenticated },
    initialClick() { return this.$store.state.player.initialClic },
    queue() { return this.$store.state.player.queue },
    displayPlayer() { return this.$store.state.player.display }
  },
  watch: {
    '$route'(to, from) {
      if (to.name === 'concert') {
        this.unlimited = true
      } else {
        this.unlimited = false
      }
      if (to.name === 'search') {
        this.displayHeader = false
        this.displayFooter = false
      } else {
        this.displayHeader = true
        this.displayFooter = true
      }
    },
    isAuthenticated(newValue) {
      if (newValue) {
        // console.log('Profile updated', newValue)
        if (this.$production.toUpperCase() === 'LISTEN') {
          this.$store.dispatch('UPDATE_USER_FOLLOWING')
          this.$store.dispatch('UPDATE_USER_PLAYLIST')
        }
      }
    }
  },
  created() {
    if (this.$route.name === 'concert') {
      this.unlimited = true
    }
    if (this.isAuthenticated) {
      // console.log('User is authenticated on mounted')
      this.$store.dispatch('UPDATE_USER_FOLLOWING')
      this.$store.dispatch('UPDATE_USER_PLAYLIST')
    }
    // auto display player and random mode
    if (this.$production.toUpperCase() === 'LISTEN') {
      if (this.$route.name !== 'playlistById' && this.$route.name !== 'trackById') {
        if (!this.initialClick && this.queue.length === 0) {
          this.$store.commit('TOGGLE_PLAYER_RANDOM', true)
          this.$store.dispatch('RANDOM_POOL').then(res => {
            this.$store.commit('TOGGLE_PLAYER_DISPLAY', true)
          })
        }
      } else {
        if (!this.displayPlayer) {
          this.$store.commit('TOGGLE_PLAYER_DISPLAY', true)
        }
      }
    }
  },
  mounted() {},
  updated() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>
